import React, { useState } from 'react';
import { Container, ThisCard, ScrollOS } from './styles';

import IconSolicitaAtivo from '~/assets/icones/IconSolicitaAtivo.svg';
import IconSolicitaAtivoB from '~/assets/icones/IconSolicitaAtivoB.svg';

function CustomBodyContent({ data }) {
  const [linhaAtiva, setLinhaAtiva] = useState([]);

  return (
    <Container>
      <ScrollOS>
        <div className="content-ct">
          {data?.map((thisData, i) => (
            <ThisCard
              className={
                linhaAtiva === thisData?.id ? 'card-item ativo' : 'card-item'
              }
              {...{ data: thisData, linhaAtiva, setLinhaAtiva }}
              key={thisData?.id || i}
              id={thisData?.id || i}
              index={i}
              ativo={linhaAtiva === thisData?.id ? true : false}
            >
              <div className="card-body">
                <div className="card-text">
                  <p className="solicitante">{thisData?.nome}</p>
                  <p className="cliente">{thisData?.cliente?.nomeFantasia}</p>
                </div>
              </div>
              <div className="card">
                <img src={localStorage.getItem("tema") == "E" ? IconSolicitaAtivo : IconSolicitaAtivoB} alt="Vazio" />
              </div>
            </ThisCard>
          ))}
        </div>
      </ScrollOS>
    </Container>
  );
}

export default CustomBodyContent;
